<div class="upload-area" [class.withBorder]="selectedImage">
  <div class="image-drop-area" *ngIf="!selectedImage"
       (dragover)="handleDragOver($event)"
       (dragleave)="handleDragLeave()"
       (drop)="handleDrop($event)"
       (click)="imageInput.click()"
       [class.dragging]="isDragging">
    <img src="assets/icons/club-cover-pic.svg" alt="">
    <span>
      Cliquer ici pour parcourir et <span class="highlight">télécharger</span>
    </span>
    <input type="file" #imageInput hidden
           (change)="handleFileInput($event)"
           accept="image/png, image/jpeg, image/jpg" />
  </div>

  <div class="image-preview" *ngIf="selectedImage">
    <img class="selected-img" [src]="selectedImage" alt="Cover pic" />
    <img class="delete-img"
         (click)="removeImage()"
         src="assets/icons/delete-club.svg" alt="">
  </div>
</div>
